module.exports = __webpack_public_path__ + "img/kia-logo.6c94a85c.png";